import { IConditionalNode } from '@shared/helpers/conditional-nodes.helpers';
import {
  ConcretePropertyName,
  ConcreteType,
  ConcreteQuality,
} from './concrete.model';
import { ConcreteProducts } from './concrete.model';

export const concreteProductNodes: IConditionalNode<ConcreteProducts> = {
  property: ConcretePropertyName.Type,
  map: {
    [ConcreteType.CastInPlace]: [
      {
        conditions: {
          [ConcretePropertyName.Quality]: [ConcreteQuality.C20_25],
        },
        nodes: [ConcreteProducts.C20_25],
      },
      {
        conditions: {
          [ConcretePropertyName.Quality]: [ConcreteQuality.C25_30],
        },
        nodes: [ConcreteProducts.C25_30],
      },
      {
        conditions: {
          [ConcretePropertyName.Quality]: [ConcreteQuality.C28_35],
        },
        nodes: [ConcreteProducts.C28_35],
      },
      {
        conditions: {
          [ConcretePropertyName.Quality]: [ConcreteQuality.C30_37],
        },
        nodes: [ConcreteProducts.C30_37],
      },
      {
        conditions: {
          [ConcretePropertyName.Quality]: [ConcreteQuality.C32_40],
        },
        nodes: [ConcreteProducts.C32_40],
      },
      {
        conditions: {
          [ConcretePropertyName.Quality]: [ConcreteQuality.C35_45],
        },
        nodes: [ConcreteProducts.C35_45],
      },
      {
        conditions: {
          [ConcretePropertyName.Quality]: [ConcreteQuality.C40_50],
        },
        nodes: [ConcreteProducts.C40_50],
      },
      {
        conditions: {
          [ConcretePropertyName.Quality]: [ConcreteQuality.C45_55],
        },
        nodes: [ConcreteProducts.C45_55],
      },
      {
        conditions: {
          [ConcretePropertyName.Quality]: [ConcreteQuality.C50_60],
        },
        nodes: [ConcreteProducts.C50_60],
      },
      {
        conditions: {
          [ConcretePropertyName.Quality]: [ConcreteQuality.C55_67],
        },
        nodes: [ConcreteProducts.C55_67],
      },
      {
        conditions: {
          [ConcretePropertyName.Quality]: [ConcreteQuality.C60_75],
        },
        nodes: [ConcreteProducts.C60_75],
      },
    ],
    [ConcreteType.BalconyAndStairs]: [ConcreteProducts.BalconyAndStairs],
    [ConcreteType.BalconyAccessSlab]: [ConcreteProducts.BalconyAccessSlab],
    [ConcreteType.BeamsPrestressed]: [ConcreteProducts.BeamsPrestressed],
    [ConcreteType.BeamsSlackReinforced]: [
      ConcreteProducts.BeamsSlackReinforced,
    ],
    [ConcreteType.FloorPlatesForFloorSystems]: [
      ConcreteProducts.FloorPlatesForFloorSystems,
    ],
    [ConcreteType.HollowCoreFloors]: [ConcreteProducts.HollowCoreFloors],
    [ConcreteType.SolidFloorStructure]: [ConcreteProducts.SolidFloorStructure],
    [ConcreteType.TTConcreteSlabs]: [ConcreteProducts.TTConcreteSlabs],
    [ConcreteType.Columns]: [ConcreteProducts.Columns],
    [ConcreteType.ExternalWallPanels]: [ConcreteProducts.ExternalWallPanels],
    [ConcreteType.HalfSandwichWallPanel]: [
      ConcreteProducts.HalfSandwichWallPanel,
    ],
    [ConcreteType.SandwichWallPanels]: [ConcreteProducts.SandwichWallPanels],
    [ConcreteType.SolidInteriorWallPanel]: [
      ConcreteProducts.SolidInteriorWallPanel,
    ],
    [ConcreteType.ThinShellPrecastPanels]: [
      ConcreteProducts.ThinShellPrecastPanels,
    ],
    [ConcreteType.Other]: [ConcreteProducts.Other],
  },
};
